<template>
  <v-card flat>
    <v-card-title v-if="displaySearch">
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="tableData"
      :loading="loading"
      :options.sync="options"
      :server-items-length="totalCount"
      :hideActions="hideActions"
      :hideHeaders="hideHeaders"
    >
      <template #[`item.status`]="{item}">
        
        <v-chip
          v-if="isDisabled(item)"
          color="red"
          text
          label
          small
        >
          Inactive
        </v-chip>
        <v-chip
          v-else
          color="green"
          text
          label
          small
        >
          Active
        </v-chip>
      </template>
      <template v-slot:item.actions="{item}">
        <v-btn icon @click.stop="open(item.id)">
          <v-icon small>mdi-dots-horizontal</v-icon>
        </v-btn>
        <v-dialog v-model="deleteDialog[item.id]" max-width="300">
          <template #activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>Are you sure ?</v-card-title>
            <v-card-text>No products are afected by this action</v-card-text>
            <v-card-actions>
              <v-btn @click="deleteDialog[item.id] = false">Cancel</v-btn>
              <v-spacer />
              <v-btn color="red" @click="deleteItem(item.id)">
                Delete
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
    </v-data-table>
    <set-form
      :item="editedSet"
      :open="setFormOpen"
      :headers="productHeaders"
      v-on:cancel="cancelPrice()"
      v-on:update="updatePrice()"
    ></set-form>
  </v-card>
</template>

<script>
import _ from "lodash";
import SetForm from "./SetForm.vue";
import { mapActions } from 'vuex';

export default {
  components: {
    SetForm
  },
  props: {
    store: {
      type: String
    },
    headers: {
      type: Array
    },
    filters: {
      type: Object
    },
    displaySearch: {
      type: Boolean,
      default: true
    },
    hideHeaders: {
      type: Boolean,
      default: false
    },
    hideActions: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      deleteDialog: {},
      search: "",
      options: { itemsPerPage: 25 },
      editedSet: null,
      setFormOpen: false,
      selectedFilters: this.filters,
      productHeaders: [
        { text: "Code", value: "code", align: "right" },
        { text: "Sku", value: "sku", align: "left" },
        { text: "Title", value: "description" }
      ],
      tableData: [],
      totalCount: 0,
      loading: false
    };
  },
  watch: {
    options: {
      handler: _.debounce(function() {
        this.getProductSets();
      }, 100)
    },
    search: {
      handler: _.debounce(function() {
        this.getProductSets();
      }, 100)
    }
  },
  computed: {
    filterValues: function() {
      return this.$store.getters["productSets/filterValues"];
    }
  },
  mounted: function() {
    this.getProductSets(); //method1 will execute at pageload
  },
  methods: {
    ...mapActions("productSets", {deleteSet: "delete"}),
    isDisabled(set) {
      let productDisabled = set.products.find(p => p.status == 'inactive');
      return productDisabled;
    },
    getProductSets() {
      this.loading = true;
      this.$store
        .dispatch(this.store, {
          pagination: this.options,
          search: this.search,
          filters: this.selectedFilters
        })
        .then(({sets}) => {
          this.tableData = sets.data;
          this.totalCount = sets.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    open(id) {
      this.$router.push("/sets/view/" + id);
    },
    editSet(item) {
      this.editedSet = Object.assign({}, item);
      this.setFormOpen = true;
    },
    cancelPrice() {
      this.setFormOpen = false;
      this.getProductSets();
    },
    updatePrice() {
      this.setFormOpen = false;
      this.getProductSets();
    },
    deleteItem(itemId){
      this.deleteSet(itemId)
      .then(() => {
        this.getProductSets();
      })
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
      this.getProductSets();
    },
    columnValueList(val) {
      return this.tableData.map(d => d[val]);
    }
  }
};
</script>

<style lang="less" scoped></style>
